import yup from 'yup';

export const validationRegister = {
    name: yup.string().trim().required().max(35, `Значение не должно превышать 35 символов`).matches(/^[а-яА-ЯЁё -]*$/, 'Допустимы только кириллические буквы'),
    surname: yup.string().trim().required().max(35, `Значение не должно превышать 35 символов`).matches(/^[а-яА-ЯЁё -]*$/, 'Допустимы только кириллические буквы'),
    email: yup.string().email().required(),
    password: yup.string().required().matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{10,}$/, "Пароль должен содержать 10 символов, один верхний регистр, один нижний регистр и одно число"),
    password_confirmation: yup.string().required().oneOf([yup.ref('password'), null], 'Пароли не совпадают')
};


export const validationProfile = {
    name: yup.string().trim().required().max(35, `Значение не должно превышать 35 символов`).matches(/^[а-яА-ЯЁё -]*$/, 'Допустимы только кириллические буквы'),
    surname: yup.string().trim().required().max(35, `Значение не должно превышать 35 символов`).matches(/^[а-яА-ЯЁё -]*$/, 'Допустимы только кириллические буквы'),
    email: yup.string().email().required(),
    patronymic: yup.string().trim().required().max(35, `Значение не должно превышать 35 символов`).matches(/^[а-яА-ЯЁё -]*$/, 'Допустимы только кириллические буквы'),
    institution: yup.string().required(),
    education_type: yup.string().required(),
    
    phone_number: yup.string().required().min(11),
    entity_type: yup.string().required(),
    file: yup.mixed().when('without_education', {
        is: true,
        then: yup.mixed(),
        otherwise: yup.mixed().required()
    }),
    without_education: yup.bool(),
    company: yup.string().when('entity_type', {
        is: 'ENTITY',
        then: yup.string().required(),
        otherwise: yup.string()
    }),
    notification_type: yup.string().required(),
    
    facebook: yup.mixed().when(['without_education', 'instagram', 'vk', 'personal_site'], {
        is: (a, b, c, d) => a && !b && !c && !d,
        then: yup.mixed().required()
    }),
    instagram: yup.mixed().when(['without_education', 'facebook', 'vk', 'personal_site'], {
        is: (a, b, c, d) => a && !b && !c && !d,
        then: yup.mixed().required()
    }),
    vk: yup.mixed().when(['without_education', 'facebook', 'instagram', 'personal_site'], {
        is: (a, b, c, d) => a && !b && !c && !d,
        then: yup.mixed().required()
    }),
    personal_site: yup.mixed(),
};


// WEBPACK FOOTER //
// ./src/components/common/cards/UserForm.js